var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/lovely"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lovely"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9336 11.5615C20.6153 11.5615 19.4369 12.2032 18.7019 13.1832C17.9669 12.2032 16.7886 11.5615 15.4703 11.5615C13.2419 11.5615 11.4336 13.3815 11.4336 15.6215C11.4336 16.4849 11.5736 17.2899 11.8069 18.0249C12.9503 21.6532 16.4969 23.8349 18.2469 24.4299C18.4919 24.5115 18.9003 24.5115 19.1453 24.4299C20.8953 23.8349 24.4419 21.6649 25.5853 18.0249C25.8303 17.2782 25.9586 16.4849 25.9586 15.6215C25.9703 13.3815 24.1619 11.5615 21.9336 11.5615Z",
    fill: "#6210CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.207 9.72991C24.207 9.99824 23.9387 10.1732 23.682 10.1032C22.107 9.69491 20.3804 10.0332 19.0737 10.9666C18.817 11.1532 18.467 11.1532 18.222 10.9666C17.3004 10.2899 16.1804 9.91658 15.002 9.91658C11.992 9.91658 9.54203 12.3782 9.54203 15.4116C9.54203 18.7016 11.117 21.1632 12.7037 22.8082C12.7854 22.8899 12.7154 23.0299 12.6104 22.9832C9.42536 21.8982 2.33203 17.3949 2.33203 9.72991C2.33203 6.34658 5.05036 3.61658 8.41036 3.61658C10.4054 3.61658 12.167 4.57324 13.2754 6.05491C14.3954 4.57324 16.157 3.61658 18.1404 3.61658C21.4887 3.61658 24.207 6.34658 24.207 9.72991Z",
    fill: "#6210CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart_icon.8fb3176f9d14495f637a6cd2f7dec231.svg";
export { ForwardRef as ReactComponent };